import CryptoJS from 'crypto-js'
import { Buffer } from 'buffer'

type Cipher = {
  update(data: Uint8Array): Buffer
  final(): Buffer
}

const toWordArray = (value: Uint8Array) =>
  CryptoJS.enc.Hex.parse(Buffer.from(value).toString('hex'))

// aes-cmac only needs AES-CBC encryption of one block; using CryptoJS avoids
// bundling the Node crypto-browserify dependency tree into the panel.
export const createCipheriv = (
  algorithm: string,
  key: Uint8Array,
  iv: Uint8Array,
): Cipher => {
  if (!/^aes-(128|192|256)-cbc$/.test(algorithm)) {
    throw new Error(`Unsupported cipher algorithm: ${algorithm}`)
  }

  return {
    update(data) {
      const encrypted = CryptoJS.AES.encrypt(
        toWordArray(data),
        toWordArray(key),
        {
          iv: toWordArray(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.NoPadding,
        },
      )

      return Buffer.from(encrypted.ciphertext.toString(CryptoJS.enc.Hex), 'hex')
    },
    final: () => Buffer.alloc(0),
  }
}
